import { render } from "./blogPcIndex.vue?vue&type=template&id=e20bc40e"
import script from "./blogPcIndex.vue?vue&type=script&lang=js"
export * from "./blogPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__